import Block, { BlockContent } from "~/components/Block";
import Divider from "~/components/Divider";
import { getCommonSliceProps } from "~/external/prismic";
import connectSlice from "~/lib/connectSlice";

type PropType = {
  spacingTop?: number;
  spacingBottom?: number;
  backgroundColor?: string;
  color?: string;
  animateIn?: boolean;
};

function DividerSlice(props: PropType) {
  const {
    spacingTop = 0,
    spacingBottom = 6,

    color,
    backgroundColor,
    animateIn = false,
  } = props;

  return (
    <Block
      spacingTop={spacingTop}
      spacingBottom={spacingBottom}
      backgroundColor={backgroundColor}
      color={color}
    >
      <BlockContent>
        <Divider color={color} />
      </BlockContent>
    </Block>
  );
}

export function mapSliceToProps(slice) {
  const { primary, items } = slice;

  const props = {
    ...getCommonSliceProps(slice),
  };

  return props;
}

export default connectSlice(mapSliceToProps)(DividerSlice);
